import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { RenderIf } from '../utils/RenderIf';
import generateSecurePassword from '../utils/GenerateSecurePassword';
/* ── Inline SVG Icons ── */
const MIcons = {
    X: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>,
    Plus: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>,
    Check: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12" /></svg>,
    Trash: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>,
    Upload: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>,
};


// We create the modal component
const SmartpayModal = ({
    button_text,
    modal_size,
    modal_header_text,
    modal_body,
    submit,
    handleFieldChange,
    buttonModal,
    setShowModal,
    showModal,
    initialFormValues,
    formType,
    removeUserBranch,
    selectedUserOption,
    setEventHandler,
    buttonIcon,
    buttonClass,
    removeUserRole
}) => {
    // We create the state of the form
    const [formValues, setFormValues] = useState(initialFormValues || {});
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordCheck, setShowPasswordCheck] = useState(false);
    //We create the useEffect
    useEffect(() => {
        setFormValues(initialFormValues || {});
    }, [initialFormValues]);

    //We check if the modal have password field and if the form type is add form to generate a secure password
    const hasPasswordFields = modal_body?.some(
        (field) => field.name === 'pass'
    ) && modal_body?.some(
        (field) => field.name === 'passCheck'
    );

    //We create the input function 
    const handleInputChange = (name, value, isfile) => {
        if (!isfile || isfile === undefined) {
            setFormValues((prevValues) => ({
                ...prevValues,
                [name]: value,
            }));
            handleFieldChange(name, value);
        }

        if (isfile) {
            setFormValues((prevValues) => ({
                ...prevValues,
                [name]: value instanceof FileList ? value[0] : value,
            }));
            handleFieldChange(name, value instanceof FileList ? value[0] : value);
        }
    };

    //We create the checkbox function 
    const handleCheckboxChange = (name, value) => {
        setFormValues((prevValues) => {
            const newValues = { ...prevValues };
            if (!newValues[name]) {
                newValues[name] = [];
            }
            if (newValues[name].includes(value)) {
                newValues[name] = newValues[name].filter((v) => v !== value);
            } else {
                newValues[name].push(value);
            }
            // Notifica el cambio después de actualizar el estado
            handleFieldChange(name, newValues[name]);
            return newValues;
        });
    };

    //We create the form of the modal
    const modalBodyForm = () => (
        <form onSubmit={submit} className="sp-form">
            <div className="sp-form__grid">
                {modal_body.map((field, index) => (
                    <div key={index} className="sp-form__group">
                        <label className="sp-form__label" htmlFor={field.name}>{field.label}</label>

                        {/* ── SELECT ── */}
                        {field.type === 'select' ? (
                            <select
                                className="sp-form__input"
                                id={field.name}
                                name={field.name}
                                onChange={(e) => handleInputChange(field.name, e.target.value)}
                                defaultValue={formValues[field.name] || field.defaultValue}
                                required={field.required !== undefined ? field.required : false}
                            >
                                {field.options?.map((option, i) => (
                                    <option key={i} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        ) :

                        /* ── FILE ── */
                        field.type === 'file' ? (
                            <div className="sp-form__file-wrap">
                                <input
                                    className="sp-form__input sp-form__input--file"
                                    type="file"
                                    id={field.name}
                                    name={field.name}
                                    onChange={(e) => handleInputChange(field.name, e.target.files, true)}
                                    required={field.required}
                                />
                            </div>
                        ) :

                        /* ── CHECKBOX (addForm) ── */
                        field.type === 'checkbox' && formType === "addForm" ? (
                            <div className="sp-check-list">
                                {field.options.map((option, i) => {
                                    const isChecked = formValues[field.name]?.includes(option.id) || false;
                                    return (
                                        <div key={i} className={`sp-check-item ${isChecked ? 'sp-check-item--on' : ''}`}
                                            onClick={() => handleCheckboxChange(field.name, option.id)}>
                                            <div className={`sp-check ${isChecked ? 'sp-check--on' : ''}`}>
                                                <MIcons.Check />
                                            </div>
                                            <span className="sp-check-item__label">{option.name}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        ) :

                        /* ── LIST: branches (editForm) ── */
                        field.type === 'list' && field.name === "branchoffice_Id" && formType === "editForm" ? (
                            <div className="sp-tag-list">
                                {field.options.map((option, i) => (
                                    <div key={i} className="sp-tag-item">
                                        <span className="sp-tag-item__name">{option.branchoffice_name}</span>
                                        <button className="sp-tag-item__remove" type="button"
                                            onClick={() => removeUserBranch(selectedUserOption.user_id, option.branchoffice_id)}>
                                            <MIcons.Trash />
                                        </button>
                                    </div>
                                ))}
                                {field.options.length === 0 && <div className="sp-tag-empty">Sin asignaciones</div>}
                            </div>
                        ) :

                        /* ── LIST: roles (editForm) ── */
                        field.type === 'list' && field.name === "role_id" && formType === "editForm" ? (
                            <div className="sp-tag-list">
                                {field.options.map((option, i) => (
                                    <div key={i} className="sp-tag-item sp-tag-item--role">
                                        <span className="sp-tag-item__name">{option.name}</span>
                                        <button className="sp-tag-item__remove" type="button"
                                            onClick={() => removeUserRole(selectedUserOption.user_id, option.id)}>
                                            <MIcons.Trash />
                                        </button>
                                    </div>
                                ))}
                                {field.options.length === 0 && <div className="sp-tag-empty">Sin roles asignados</div>}
                            </div>
                        ) :

                        /* ── CHECKBOX (addformGeneric) ── */
                        field.type === 'checkbox' && formType === "addformGeneric" ? (
                            <div className="sp-check-list">
                                {field.options.map((option, i) => {
                                    const isChecked = formValues[field.name]?.includes(option.id) || false;
                                    return (
                                        <div key={i} className={`sp-check-item ${isChecked ? 'sp-check-item--on' : ''}`}
                                            onClick={() => handleCheckboxChange(field.name, option.id)}>
                                            <div className={`sp-check ${isChecked ? 'sp-check--on' : ''}`}>
                                                <MIcons.Check />
                                            </div>
                                            <span className="sp-check-item__label">{option.name}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        ) :

                        /* ── DEFAULT INPUT ── */
                        (
                            <input
                                className="sp-form__input"
                                type={field.type}
                                id={field.name}
                                name={field.name}
                                placeholder={field.placeholder}
                                onChange={(e) => handleInputChange(field.name, e.target.value)}
                                value={formValues[field.name] || ''}
                                required={field.required}
                            />
                        )}
                    </div>
                ))}
            </div>

            {/* Submit */}
            <div className="sp-form__footer">
                <button className="sp-btn sp-btn--secondary" type="button" onClick={() => setShowModal(false)}>
                    Cancelar
                </button>
                <button className="sp-btn sp-btn--primary" type="submit">
                    <MIcons.Check /> Guardar
                </button>
            </div>
        </form>
    );

    return (
        <>
            {/** We ask if the button of modal is necessary */}
            <RenderIf isTrue={buttonModal === true}>
                <div>
                    <button
                        className="sp-btn sp-btn--primary"
                        onClick={() => {
                            setShowModal(true);
                            if (setEventHandler !== undefined) setEventHandler(1);
                        }}>
                        <MIcons.Plus />
                        {button_text} 
                    </button>
                </div>
            </RenderIf>
            {/** Modal */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size={modal_size}
                centered
                dialogClassName="sp-modal-dialog"
            >
                <div className="sp-modal">               
                    {/* Header */}
                    <div className="sp-modal__head">
                        <div className="sp-modal__title">{modal_header_text}</div>
                        <button className="sp-modal__close" type="button" onClick={() => setShowModal(false)}>
                            <MIcons.X />
                        </button>
                    </div>
                    {/* Body */}
                    <div className="sp-modal__body">
                        {modalBodyForm()}
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default SmartpayModal;

